module.exports = __webpack_public_path__ + "img/allergan-logo.ba452a6e.svg";